export default __webpack_public_path__ + "static/media/ic_convert_down.f9a5b7f1.svg";